// Shared formatting helpers for dashboard widgets.

export function formatCurrency(amount: number, currency = 'RON'): string {
  return new Intl.NumberFormat('ro-RO', {
    style: 'currency',
    currency,
    maximumFractionDigits: 0,
  }).format(amount);
}

export function formatPercent(value: number): string {
  return `${Math.round(value * 10) / 10}%`;
}

export function formatDate(iso: string | null): string {
  if (!iso) return 'Fără termen';
  return new Intl.DateTimeFormat('ro-RO', { dateStyle: 'medium' }).format(new Date(iso));
}

// Exact moment, for the tooltip behind a relative time: "vineri, 25 septembrie 2026, 13:35".
export function formatDateTime(iso: string): string {
  return new Intl.DateTimeFormat('ro-RO', { dateStyle: 'full', timeStyle: 'short' }).format(
    new Date(iso),
  );
}

// Relative time like "acum 2 ore" (FR-DASH for activity feed timestamps).
export function relativeTime(iso: string): string {
  const then = new Date(iso).getTime();
  const diffMs = Date.now() - then;
  const sec = Math.round(diffMs / 1000);
  if (sec < 60) return 'chiar acum';
  const min = Math.round(sec / 60);
  if (min < 60) return `acum ${min} ${min === 1 ? 'minut' : 'minute'}`;
  const hr = Math.round(min / 60);
  if (hr < 24) return `acum ${hr} ${hr === 1 ? 'oră' : 'ore'}`;
  const day = Math.round(hr / 24);
  if (day < 30) return `acum ${day} ${day === 1 ? 'zi' : 'zile'}`;
  const month = Math.round(day / 30);
  if (month < 12) return `acum ${month} ${month === 1 ? 'lună' : 'luni'}`;
  const year = Math.round(month / 12);
  return `acum ${year} ${year === 1 ? 'an' : 'ani'}`;
}
